<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请选择成品"/>
</template>

<script>
  /**
   * @Description: 成品自动查询组件
   * @Author: 菩萨蛮
   * @Date: 2020/9/4 3:44 下午
   * @Version v1.0.0
   *
   * 公司的业务千篇一律，复杂的代码好几百行。
   */
  import AutoComplete from '../../../mixins/common/AutoComplete';

  export default {
    name: 'ProductAutoComplete',
    mixins: [AutoComplete],
    data() {
      return {
        url: '/base/info/product?pageSize=5&pageNum=0&code=',
        itemName: 'code'
      };
    }
  };
</script>

<style lang="scss" scoped>

</style>
